// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../statics/menu_feedback.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../statics/menu_feedback_active.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../statics/menu_collect.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../statics/menu_collect_active.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../../statics/menu_setting.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../../statics/menu_setting_active.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChatMessageHeader_container__kz0CV {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 13px 20px 0 0;
    font-size: 25px;
    color: #888;
}

.ChatMessageHeader_left__l9Auf {
    width: 300px;
    height: 100%;
    padding-left: 18px;
}

.ChatMessageHeader_right__FsNTZ {
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.ChatMessageHeader_search_box__Ewb0f {
    position: relative;
    width: 200px;
    height: 40px;
    margin-right: 20px;
}

.ChatMessageHeader_search__DACVZ {
    width: 100%;
    height: 100%;
    padding: 5px 5px 5px 30px;
    border: 1px solid #c1c1c1;
    border-radius: 6px;
    font-size: 14px;
}

.ChatMessageHeader_search_icon__DdLsI {
    position: absolute;
    top: 15px;
    left: 10px;
    width: 11px;
    height: 12px;
}

.ChatMessageHeader_search_box_mask__qhGgP {
    position: absolute;
    top: 6px;
    left: 6px;
    width: calc(100% - 12px);
    height: calc(100% - 12px);
    z-index: -1;
}

.ChatMessageHeader_search_info__zt5j8 {
    position: absolute;
    left: 0;
    top: 56px;
    z-index: 101;
    width: 214px;
    height: 214px;
    padding: 16px;
    border-radius: 12px;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
    background-color: #fff;
    overflow-x: hidden;
    overflow-y: scroll;
}

/* 自定义滚动条 */
.ChatMessageHeader_search_info__zt5j8::-webkit-scrollbar {/*滚动条整体样式*/
    -webkit-appearance: none;
    width: 5px;
    height: 5px;
}

.ChatMessageHeader_search_info__zt5j8::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    cursor: pointer;
    border-radius: 5px;
    background: #e9e9e9;
    -webkit-transition: color .2s ease;
    transition: color .2s ease;
}

.ChatMessageHeader_search_info__zt5j8::-webkit-scrollbar-thumb:hover {
    background: #e3e3e3;
}

.ChatMessageHeader_search_info_header__aJet8 {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 20px;
    font-size: 14px;
    color: #7e8b9e;
    margin-bottom: 16px;
}

.ChatMessageHeader_search_info_item__9ZQci {
    margin-bottom: 10px;
}

.ChatMessageHeader_search_info_item_box__pNwyS {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 27px;
    margin-bottom: 10px;
    cursor: pointer;
    border-radius: 6px;
}

.ChatMessageHeader_search_info_item_box__pNwyS:hover {
    background-color: #dfdfdf;
}

.ChatMessageHeader_search_info_item_box__pNwyS:active {
    background-color: #cdcdcd;
}

.ChatMessageHeader_search_info_item_line__zFu0c {
    width: 100%;
    height: 1px;
    border-bottom: 1px solid #CACFDB;
    margin-bottom: 10px;
}

.ChatMessageHeader_search_info_item_icon__ZXNMT {
    width: 24px;
    height: 24px;
    margin-right: 10px;
}

.ChatMessageHeader_search_info_item_name__Ca8Y5 {
    width: calc(100% - 24px - 10px);
    font-size: 14px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

.ChatMessageHeader_img_box__5IdYx {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
}

/* .img_box:hover {
    background-color: #ccc;
} */

.ChatMessageHeader_img__mMWeJ {
    width: 24px;
    height: 24px;
    cursor: pointer;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
}

.ChatMessageHeader_feedback_img__Cz6LY {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.ChatMessageHeader_feedback_img__Cz6LY:hover {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.ChatMessageHeader_collect_img__yftp- {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.ChatMessageHeader_collect_img__yftp-:hover {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.ChatMessageHeader_setting_img__9GGmX {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.ChatMessageHeader_setting_img__9GGmX:hover {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

@keyframes ChatMessageHeader_fadeIn__RusoE {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
}

.ChatMessageHeader_fade_in__I1uva {
    animation-name: ChatMessageHeader_fadeIn__RusoE;
    /* 动画持续时间为0.5秒 */
    animation-duration: 0.5s;
    /* 动画完成后保持最终状态 */
    animation-fill-mode: forwards;
}

.ChatMessageHeader_select_box__VhWjV {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
}

.ChatMessageHeader_personal_back__3E0do {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 150px;
    height: 100%;
    font-family: 'PingFangSCMedium';
    font-weight: bold;
    color: #101417;
    font-size: 20px;
    cursor: pointer;
}

.ChatMessageHeader_personal_back_img__\\+v4pc {
    margin-right: 10px;
}

.ChatMessageHeader_middle__Ote\\+q {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 300px;
    height: 100%;
    padding-right: 50px;
}

.ChatMessageHeader_middle_text_box__X-mut {
    font-size: 14px;
}

.ChatMessageHeader_middle_text_num__V\\+L-W {
    font-weight: bold;
    color: #323a45;
    margin-left: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/home/components/ChatMessageHeader/index.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,sBAAsB;IACtB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,wBAAwB;IACxB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,sCAAsC;IACtC,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,WAAW;AACX,0DAAiC,UAAU;IACvC,wBAAwB;IACxB,UAAU;IACV,WAAW;AACf;;AAEA,gEAAuC,WAAW;IAC9C,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IAEnB,kCAA0B;IAA1B,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,WAAW;IACX,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;IAC/B,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;;GAEG;;AAEH;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,4BAA4B;IAC5B,kCAAkC;AACtC;;AAEA;IACI,yDAA8D;AAClE;;AAEA;IACI,yDAAqE;AACzE;;AAEA;IACI,yDAA6D;AACjE;;AAEA;IACI,yDAAoE;AACxE;;AAEA;IACI,yDAA6D;AACjE;;AAEA;IACI,yDAAoE;AACxE;;AAEA;IACI;MACE,UAAU;IACZ;IACA;MACE,UAAU;IACZ;AACJ;;AAEA;IACI,+CAAsB;IACtB,gBAAgB;IAChB,wBAAwB;IACxB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,+BAA+B;IAC/B,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,iBAAiB;AACrB","sourcesContent":[".container {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    padding: 13px 20px 0 0;\n    font-size: 25px;\n    color: #888;\n}\n\n.left {\n    width: 300px;\n    height: 100%;\n    padding-left: 18px;\n}\n\n.right {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n}\n\n.search_box {\n    position: relative;\n    width: 200px;\n    height: 40px;\n    margin-right: 20px;\n}\n\n.search {\n    width: 100%;\n    height: 100%;\n    padding: 5px 5px 5px 30px;\n    border: 1px solid #c1c1c1;\n    border-radius: 6px;\n    font-size: 14px;\n}\n\n.search_icon {\n    position: absolute;\n    top: 15px;\n    left: 10px;\n    width: 11px;\n    height: 12px;\n}\n\n.search_box_mask {\n    position: absolute;\n    top: 6px;\n    left: 6px;\n    width: calc(100% - 12px);\n    height: calc(100% - 12px);\n    z-index: -1;\n}\n\n.search_info {\n    position: absolute;\n    left: 0;\n    top: 56px;\n    z-index: 101;\n    width: 214px;\n    height: 214px;\n    padding: 16px;\n    border-radius: 12px;\n    box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);\n    background-color: #fff;\n    overflow-x: hidden;\n    overflow-y: scroll;\n}\n\n/* 自定义滚动条 */\n.search_info::-webkit-scrollbar {/*滚动条整体样式*/\n    -webkit-appearance: none;\n    width: 5px;\n    height: 5px;\n}\n\n.search_info::-webkit-scrollbar-thumb {/*滚动条里面小方块*/\n    cursor: pointer;\n    border-radius: 5px;\n    background: #e9e9e9;\n    -webkit-transition: color .2s ease;\n    transition: color .2s ease;\n}\n\n.search_info::-webkit-scrollbar-thumb:hover {\n    background: #e3e3e3;\n}\n\n.search_info_header {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    width: 100%;\n    height: 20px;\n    font-size: 14px;\n    color: #7e8b9e;\n    margin-bottom: 16px;\n}\n\n.search_info_item {\n    margin-bottom: 10px;\n}\n\n.search_info_item_box {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    width: 100%;\n    height: 27px;\n    margin-bottom: 10px;\n    cursor: pointer;\n    border-radius: 6px;\n}\n\n.search_info_item_box:hover {\n    background-color: #dfdfdf;\n}\n\n.search_info_item_box:active {\n    background-color: #cdcdcd;\n}\n\n.search_info_item_line {\n    width: 100%;\n    height: 1px;\n    border-bottom: 1px solid #CACFDB;\n    margin-bottom: 10px;\n}\n\n.search_info_item_icon {\n    width: 24px;\n    height: 24px;\n    margin-right: 10px;\n}\n\n.search_info_item_name {\n    width: calc(100% - 24px - 10px);\n    font-size: 14px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n}\n\n.img_box {\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 24px;\n    height: 24px;\n}\n\n/* .img_box:hover {\n    background-color: #ccc;\n} */\n\n.img {\n    width: 24px;\n    height: 24px;\n    cursor: pointer;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center center;\n}\n\n.feedback_img {\n    background-image: url('../../../../statics/menu_feedback.png');\n}\n\n.feedback_img:hover {\n    background-image: url('../../../../statics/menu_feedback_active.png');\n}\n\n.collect_img {\n    background-image: url('../../../../statics/menu_collect.png');\n}\n\n.collect_img:hover {\n    background-image: url('../../../../statics/menu_collect_active.png');\n}\n\n.setting_img {\n    background-image: url('../../../../statics/menu_setting.png');\n}\n\n.setting_img:hover {\n    background-image: url('../../../../statics/menu_setting_active.png');\n}\n\n@keyframes fadeIn {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n}\n\n.fade_in {\n    animation-name: fadeIn;\n    /* 动画持续时间为0.5秒 */\n    animation-duration: 0.5s;\n    /* 动画完成后保持最终状态 */\n    animation-fill-mode: forwards;\n}\n\n.select_box {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 14px;\n}\n\n.personal_back {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 150px;\n    height: 100%;\n    font-family: 'PingFangSCMedium';\n    font-weight: bold;\n    color: #101417;\n    font-size: 20px;\n    cursor: pointer;\n}\n\n.personal_back_img {\n    margin-right: 10px;\n}\n\n.middle {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 300px;\n    height: 100%;\n    padding-right: 50px;\n}\n\n.middle_text_box {\n    font-size: 14px;\n}\n\n.middle_text_num {\n    font-weight: bold;\n    color: #323a45;\n    margin-left: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ChatMessageHeader_container__kz0CV`,
	"left": `ChatMessageHeader_left__l9Auf`,
	"right": `ChatMessageHeader_right__FsNTZ`,
	"search_box": `ChatMessageHeader_search_box__Ewb0f`,
	"search": `ChatMessageHeader_search__DACVZ`,
	"search_icon": `ChatMessageHeader_search_icon__DdLsI`,
	"search_box_mask": `ChatMessageHeader_search_box_mask__qhGgP`,
	"search_info": `ChatMessageHeader_search_info__zt5j8`,
	"search_info_header": `ChatMessageHeader_search_info_header__aJet8`,
	"search_info_item": `ChatMessageHeader_search_info_item__9ZQci`,
	"search_info_item_box": `ChatMessageHeader_search_info_item_box__pNwyS`,
	"search_info_item_line": `ChatMessageHeader_search_info_item_line__zFu0c`,
	"search_info_item_icon": `ChatMessageHeader_search_info_item_icon__ZXNMT`,
	"search_info_item_name": `ChatMessageHeader_search_info_item_name__Ca8Y5`,
	"img_box": `ChatMessageHeader_img_box__5IdYx`,
	"img": `ChatMessageHeader_img__mMWeJ`,
	"feedback_img": `ChatMessageHeader_feedback_img__Cz6LY`,
	"collect_img": `ChatMessageHeader_collect_img__yftp-`,
	"setting_img": `ChatMessageHeader_setting_img__9GGmX`,
	"fade_in": `ChatMessageHeader_fade_in__I1uva`,
	"fadeIn": `ChatMessageHeader_fadeIn__RusoE`,
	"select_box": `ChatMessageHeader_select_box__VhWjV`,
	"personal_back": `ChatMessageHeader_personal_back__3E0do`,
	"personal_back_img": `ChatMessageHeader_personal_back_img__+v4pc`,
	"middle": `ChatMessageHeader_middle__Ote+q`,
	"middle_text_box": `ChatMessageHeader_middle_text_box__X-mut`,
	"middle_text_num": `ChatMessageHeader_middle_text_num__V+L-W`
};
export default ___CSS_LOADER_EXPORT___;
